module.exports = __webpack_public_path__ + "img/lisa_n_3.8faf543c.png";